import React from "react";
import clsx from "clsx";

const TextField = ( props ) => {

  const {
    className,
    children,
    ...PROPS
  } = props;

  return (
    <div className={ clsx( 'input_box', className ) }>
      <input type="text" { ...PROPS } />
    </div>
  );

};

export default TextField;
